import { Box, Button, Grid, Typography } from "@mui/material";
import { ArrowForward } from "@mui/icons-material";
import hero1 from "../../assets/finance/1.png";
import CustomText, { textStyles } from "../../components/CustomText";
import { useMediaQuery, } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import more from "../../assets/more.svg";
import GetAppButton from "../../components/GetAppButton";
import FeaturesHeroCard from "../../components/cards/FeaturesHeroCard";
import FeaturesBigHeroCard from "../../components/cards/FeaturesBigHeroCard";
import hero2 from "../../assets/finance/2.png";
import hero3 from "../../assets/finance/3.png";
import hero4 from "../../assets/hero4.png";
import hero6 from "../../assets/finance/5.png";
import hero7 from "../../assets/finance/6.png";
import { useEffect ,useState} from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import hero1es from "../../assets/spanish/Financial/hero1es.webp";
import hero2es from "../../assets/spanish/Financial/hero2es.webp";
import hero5es from "../../assets/spanish/Financial/hero5es.webp";
import hero4es from "../../assets/spanish/Financial/hero4es.webp";
import hero6es from "../../assets/spanish/Financial/hero6es.webp";
import heroes from "../../assets/spanish/Financial/heroes.webp";
import hearo8 from "../../assets/spanish/Financial/hearo8.webp";
import heroimage from "../../assets/finance/heroimage.webp";
import herocard1 from "../../assets/finance/herocard1.webp";
import herocard2 from "../../assets/finance/herocard2.webp";
import herocard3 from "../../assets/finance/herocard3.webp";
import herocard4 from "../../assets/finance/herocard4.webp";
import herocard5 from '../../assets/finance/herocard5.webp';
import Skeleton from "@mui/material/Skeleton";
import { BASE_URL } from "../../components/BASE_URL";
import { useSocialLinks } from "../../components/fetchGetAppUrl";
const HeroSection = () => {
  const { t, i18n } = useTranslation();
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down("lg"))
  const hero_section_button_text = {
    main: "var(--Tertiary, #003149)",
    hover: "#00263a",
    contrastText: "#FFFFFF",
    fontSize: "18px",
  }
  const location = useLocation();
  useEffect(() => {
    const hash = window.location.hash;

    if (hash) {
      // Give time for DOM/rendering/layout/styles to finish
      setTimeout(() => {
        const id = hash.replace("#", "");
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }, 300); // Adjust timeout if needed
    }
  }, []);



  useEffect(() => {
    if (location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);
  const navigate = useNavigate()
  const handleMore = () => {
    navigate("/product-tour")
  }
  const heroImageSrc = i18n.language === "es" ? hero1es : heroimage;
  const card1 = i18n.language === "es" ? hero2es : herocard1;
  const card2 = i18n.language === "es" ? heroes : herocard2;
  const card3 = i18n.language === "es" ? hearo8 : herocard3;
  const card4 = i18n.language === "es" ? hero4es : herocard4;
  const card5 = i18n.language === "es" ? hero6es : herocard5;

  const parseFeatureNames = (list) => {
    try {
      const items = Array.isArray(list)
        ? list
        : list
          ? JSON.parse(list)
          : [];
      return items.map((f) => f.name);
    } catch {
      return [];
    }
  };

  const [loading, setLoading] = useState(true);
  const [heroData, setHeroData] = useState(null);
 useEffect(() => {
  const fetchHeroData = async () => {
    try {
      const response = await fetch(
        `${BASE_URL}content/sections?page=1&limit=10&sort=order&include=items&search=Financial_Feature`
      );
      const data = await response.json();

      if (!data.error && data.data?.length > 0) {
        const section = data.data[0];

        // 🔹 Choose EN or ES item
        const item =
          i18n.language === "es"
            ? section.items.find(it => it.idx === 1)
            : section.items.find(it => it.idx === 0);

        setHeroData({
          title: item?.title || "",
          description: item?.description || "",
          features: [], // no list in this API, but keeping structure consistent
        });
      }
    } catch (error) {
      console.error("Error fetching Financial_Feature:", error);
    } finally {
      setLoading(false);
    }
  };

  fetchHeroData();
}, [i18n.language]);


  const [loadingSalary, setLoadingSalary] = useState(true);
const [salaryCardData, setSalaryCardData] = useState(null);

  const { links } = useSocialLinks();

useEffect(() => {
  const fetchSalaryCard = async () => {
    try {
      const response = await fetch(
        `${BASE_URL}content/sections?page=1&limit=10&sort=order&include=items&search=Salary_payments`
      );
      const data = await response.json();
      if (!data.error && data.data?.length > 0) {
        const section = data.data[0];
        const item =
          i18n.language === "es"
            ? section.items.find(it => it.idx === 1)
            : section.items.find(it => it.idx === 0);

        setSalaryCardData({
          title: item?.title || "",
          description: item?.description || "",
          features: parseFeatureNames(item?.list),
        });
      }
    } catch (error) {
      console.error("Error fetching salary card:", error);
    } finally {
      setLoadingSalary(false);
    }
  };

  fetchSalaryCard();
}, [i18n.language]);



// State for Employee Logs Card
const [loadingEmployeeLogs, setLoadingEmployeeLogs] = useState(true);
const [employeeLogsCardData, setEmployeeLogsCardData] = useState(null);

useEffect(() => {
  const fetchEmployeeLogs = async () => {
    try {
      const response = await fetch(
        `${BASE_URL}content/sections?page=1&limit=10&sort=order&include=items&search=Employee_Logs`
      );
      const data = await response.json();
      if (!data.error && data.data?.length > 0) {
        const section = data.data[0];
        const item =
          i18n.language === "es"
            ? section.items.find(it => it.idx === 1)
            : section.items.find(it => it.idx === 0);

        setEmployeeLogsCardData({
          title: item?.title || "",
          description: item?.description || "",
          features: parseFeatureNames(item?.list),
        });
      }
    } catch (error) {
      console.error("Error fetching employee logs card:", error);
    } finally {
      setLoadingEmployeeLogs(false);
    }
  };

  fetchEmployeeLogs();
}, [i18n.language]);



// State for Loan Management Card
const [loadingLoan, setLoadingLoan] = useState(true);
const [loanCardData, setLoanCardData] = useState(null);

useEffect(() => {
  const fetchLoanCard = async () => {
    try {
      const response = await fetch(
        `${BASE_URL}content/sections?page=1&limit=10&sort=order&include=items&search=Loan_Management`
      );
      const data = await response.json();
      if (!data.error && data.data?.length > 0) {
        const section = data.data[0];
        const item =
          i18n.language === "es"
            ? section.items.find(it => it.idx === 1)
            : section.items.find(it => it.idx === 0);

        setLoanCardData({
          title: item?.title || "",
          description: item?.description || "",
          features: parseFeatureNames(item?.list),
        });
      }
    } catch (error) {
      console.error("Error fetching loan management card:", error);
    } finally {
      setLoadingLoan(false);
    }
  };

  fetchLoanCard();
}, [i18n.language]);



// State for Employee History Card
const [loadingHistory, setLoadingHistory] = useState(true);
const [historyCardData, setHistoryCardData] = useState(null);

useEffect(() => {
  const fetchHistoryCard = async () => {
    try {
      const response = await fetch(
        `${BASE_URL}content/sections?page=1&limit=10&sort=order&include=items&search=Employee_History`
      );
      const data = await response.json();
      if (!data.error && data.data?.length > 0) {
        const section = data.data[0];
        const item =
          i18n.language === "es"
            ? section.items.find(it => it.idx === 2)
            : section.items.find(it => it.idx === 0);

        setHistoryCardData({
          title: item?.title || "",
          description: item?.description || "",
          features: parseFeatureNames(item?.list),
        });
      }
    } catch (error) {
      console.error("Error fetching employee history card:", error);
    } finally {
      setLoadingHistory(false);
    }
  };

  fetchHistoryCard();
}, [i18n.language]);



// State for Subscription & Billing Card
const [loadingBilling, setLoadingBilling] = useState(true);
const [billingCardData, setBillingCardData] = useState(null);

useEffect(() => {
  const fetchBillingCard = async () => {
    try {
      const response = await fetch(
        `${BASE_URL}content/sections?page=1&limit=10&sort=order&include=items&search=Subscription_Billing`
      );
      const data = await response.json();
      if (!data.error && data.data?.length > 0) {
        const section = data.data[0];
        const item =
          i18n.language === "es"
            ? section.items.find(it => it.idx === 1)
            : section.items.find(it => it.idx === 0);

        setBillingCardData({
          title: item?.title || "",
          description: item?.description || "",
          features: parseFeatureNames(item?.list),
        });
      }
    } catch (error) {
      console.error("Error fetching subscription billing card:", error);
    } finally {
      setLoadingBilling(false);
    }
  };

  fetchBillingCard();
}, [i18n.language]);


  return (
    <>
      <Box
        id='features-screen'
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          justifyContent: "space-between",
          alignItems: "center",
          px: isMobile ? 2 : 8,
          py: 6,
          backgroundColor: "#fff",
          gap: 8,
          marginTop: '70px',
          scrollMarginTop: "150px",
        }}
      >
        <Box
          sx={{
            flex: 1,
            textAlign: { xs: "center", md: "left" },

          }}
        >
        
          {loading ? (
          <>
            <Skeleton
              variant="text"
              width={isMobile ? 250 : 400}
              height={60}
              sx={{ mx: isMobile ? "auto" : 0 }}
            />
            <Skeleton
              variant="text"
              width={isMobile ? 280 : 500}
              height={30}
              sx={{ mx: isMobile ? "auto" : 0 }}
            />
          </>
        ) : (
          <>
            <CustomText
              style={{
                ...textStyles.h1,
                marginBottom: isMobile ? "0rem" : "1rem",
                marginTop: isMobile ? "0rem" : "1rem",
                fontSize: isMobile ? "36px" : "52px",
                textAlign: isMobile ? "center" : "left",
              }}
            >
              {heroData?.title}
            </CustomText>

            <CustomText
              style={{
                ...textStyles.body1,
                color: "#868282",
                margin: "0 auto",
                marginTop: "10px",
                textAlign: isMobile ? "center" : "left",
              }}
            >
              {heroData?.description}
            </CustomText>
          </>
        )}

          <Box
            sx={{
              display: "flex",
              flexWrap: isMobile ? "wrap" : "nowrap",
              justifyContent: isMobile ? "center" : "flex-start",
              alignItems: "center",
              mt: isMobile ? "10px" : 4,
              gap: 1,
            }}
          >
            <GetAppButton
              label={t("get_app_now")}
              variant="primary" size="large" />
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: 0,
                cursor: "pointer",
              }}
              onClick={handleMore}
            >
              <img src={more || "/placeholder.svg"} style={{ width: "65px", height: "65px" }} />
              <p
                style={{
                  color: hero_section_button_text.main,
                  fontSize: "18px",
                  fontWeight: 600,
                  fontFamily: "Poppins, sans-serif",
                  cursor: "pointer",
                }}
              >
                {t("Learn More")}
              </p>
            </Box>
          </Box>
        </Box>
        <Box
          sx={{
            flex: 1,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            mt: { xs: 4, md: 0 },
          }}
        >
          <Box
            component="img"
            src={heroImageSrc}
            alt="Dashboard Preview"
            sx={{
              width: "110%",
              // maxWidth: "630px",
              height: "auto",
            }}
          />
        </Box>
      </Box>
      <Box>
      
        <Box id="finance-expense-system">
  {loadingSalary ? (
    <Box sx={{ p: 3 }}>
      <Skeleton variant="text" width={250} height={40} />
      <Skeleton variant="text" width={400} height={20} />
      <Skeleton variant="rectangular" width="100%" height={150} sx={{ mt: 2 }} />
    </Box>
  ) : (
    <FeaturesHeroCard
      bgColor="#EFF4F8"
      image={card1}
      imagePosition="left"
      title={salaryCardData?.title}
      description={salaryCardData?.description}
      features={salaryCardData?.features}
    />
  )}
</Box>



<Box
  id="finance-worker-billing"
  sx={{
    scrollMarginTop: "60px",
  }}
>
  {loadingEmployeeLogs ? (
    <Box sx={{ p: 3 }}>
      <Skeleton variant="text" width={250} height={40} />
      <Skeleton variant="text" width={400} height={20} />
      <Skeleton variant="rectangular" width="100%" height={150} sx={{ mt: 2 }} />
    </Box>
  ) : (
    <FeaturesBigHeroCard
      bgColor="#FFFFFF"
      image={card2}
      imagePosition="left"
      title={employeeLogsCardData?.title}
      description={employeeLogsCardData?.description}
      features={employeeLogsCardData?.features}
    />
  )}
</Box>
       


        <Box
  id="finance-salary-payroll-logs"
  sx={{
    scrollMarginTop: "-10px",
  }}
>
  {loadingLoan ? (
    <Box sx={{ p: 3 }}>
      <Skeleton variant="text" width={250} height={40} />
      <Skeleton variant="text" width={400} height={20} />
      <Skeleton variant="rectangular" width="100%" height={150} sx={{ mt: 2 }} />
    </Box>
  ) : (
    <FeaturesHeroCard
      bgColor="#EFF4F8"
      image={card3}
      imagePosition="right"
      title={loanCardData?.title}
      description={loanCardData?.description}
      features={loanCardData?.features}
    />
  )}
</Box>

       

        <Box
  id="finance-salary-logs"
  sx={{
    scrollMarginTop: "80px",
  }}
>
  {loadingHistory ? (
    <Box sx={{ p: 3 }}>
      <Skeleton variant="text" width={250} height={40} />
      <Skeleton variant="text" width={400} height={20} />
      <Skeleton variant="rectangular" width="100%" height={150} sx={{ mt: 2 }} />
    </Box>
  ) : (
    <FeaturesBigHeroCard
      bgColor="#FFFFFF"
      image={card4}
      imagePosition="right"
      title={historyCardData?.title}
      description={historyCardData?.description}
      features={historyCardData?.features}
    />
  )}
</Box>
      


        <Box id="finance-payment-history">
  {loadingBilling ? (
    <Box sx={{ p: 3 }}>
      <Skeleton variant="text" width={250} height={40} />
      <Skeleton variant="text" width={400} height={20} />
      <Skeleton variant="rectangular" width="100%" height={150} sx={{ mt: 2 }} />
    </Box>
  ) : (
    <FeaturesHeroCard
      bgColor="#EFF4F8"
      image={card5}
      imagePosition="left"
      title={billingCardData?.title}
      description={billingCardData?.description}
      features={billingCardData?.features}
    />
  )}
</Box>


      </Box>
    </>
  );
}
export default HeroSection
